<template>
  <div class="addressManage">
    <!-- 设置按钮 -->
    <div class="topBar_actions">
      <Popover v-model:show="showPopover" theme="dark" :actions="actions" placement="bottom-end" @select="onSelect">
        <template #reference>
          <Icon name="setting-o" />
        </template>
      </Popover>
    </div>

    <!-- 主卡片 -->
    <div class="mainCard">
      <!-- 表格头 -->
      <div class="cardHeader" v-if="show_data.length > 0">
        <span>商铺名称</span>
        <span>所在省</span>
        <span>所在市</span>
        <span>所在县(区)</span>
        <span>详细地址</span>
        <span>操作</span>
      </div>
      <!-- 表格体（可滚动） -->
      <div class="cardBody" v-if="show_data.length > 0">
        <div class="tableRow" v-for="(item,i) in show_data" :key="i">
          <span>{{ item.shopsname }}</span>
          <span>{{ item.province }}</span>
          <span>{{ item.city }}</span>
          <span>{{ item.county }}</span>
          <span class="addrText">{{ item.address }}</span>
          <span class="rowActions">
            <span class="actionBtn actionBtn--del" @click="delAddress_click(item)">删除</span>
          </span>
        </div>
      </div>
      <div class="emptyTip" v-else>暂无数据</div>
    </div>

    <!-- 分页吸底 -->
    <div class="cardFooter" v-if="show_data.length > 0 && pageInfo.total_items > 10">
      <Pagination v-model="totalPage" :total-items="pageInfo.dataTotal" :show-page-size="pageInfo.show_page_size" :items-per-page="pageInfo.items_per_page" @change="cahangePage"/>
      <span class="pageInfo">共 {{((totalPage-1)*15+show_data.length)}} / {{pageInfo.total_items}}</span>
    </div>

    <!-- 新增按钮 -->
    <div class="addBtn" @click="add_address">+</div>

    <!-- 新增/导入弹窗 -->
    <Overlay :show="add_address_show" @click="close_address_overlay">
      <div class="overlayCard" @click.stop>
        <div class="overlayClose" @click="close_address_overlay">&times;</div>
        <div class="overlayTitle">新增地址</div>
        <div class="typeTabs">
          <div class="typeTab" :class="{'typeTab--active':select_address_type==1}" @click="upLoad_barChange(1)">单条</div>
          <div class="typeTab" :class="{'typeTab--active':select_address_type==2}" @click="upLoad_barChange(2)">Excel导入</div>
        </div>
        <div v-if="select_address_type==1">
          <div class="tips">直辖市省份填写直辖市名</div>
          <Form @submit="queryAddress">
            <Field :rules="[{ required: true, message: '请填写店铺名称' }]" placeholder="店铺名称（必填）" type="text" v-model="one_update_address.shopsName"></Field>
            <Field :rules="[{ required: true, message: '请填写省份' }]" placeholder="省份（必填）" type="text" v-model="one_update_address.province"></Field>
            <Field :rules="[{ required: true, message: '请填写所在市' }]" placeholder="所在市（必填）" type="text" v-model="one_update_address.city"></Field>
            <Field :rules="[{ required: true, message: '请填写所在区县' }]" placeholder="所在区县（必填）" type="text" v-model="one_update_address.county"></Field>
            <Field :rules="[{ required: true, message: '请填写详细地址' }]" placeholder="详细地址（必填）" type="text" v-model="one_update_address.address"></Field>
            <Button type="primary" size="large" class="submitBtn" :loading="query_loading" native-type="submit" loading-text="查询中...">上传</Button>
          </Form>
        </div>
        <div v-else>
          <input type="file" accept=".xls,.xlsx" @change="handleFileUpload" class="fileUploader" id="fileInput"/>
        </div>
      </div>
    </Overlay>

    <!-- Excel 预览弹窗 -->
    <Overlay :show="excelData.length>0" @click="close_excel_data" v-if="excelData.length>0">
      <div class="excelPreview" @click.stop>
        <div class="excelPreviewTitle">授权商铺</div>
        <div class="excelPreviewClose" @click="close_excel_data">&times;</div>
        <div class="excelPreviewHeader">
          <span>商铺名称</span>
          <span>省</span>
          <span>市</span>
          <span>县(区)</span>
          <span>详细地址</span>
        </div>
        <div class="excelPreviewBody">
          <div class="excelRow" v-for="(item,i) in excelData" :key="i">
            <span v-for="(items,a) in item" :key="a">{{ a==0 ? (i+1)+'.'+items : items }}</span>
          </div>
        </div>
        <div class="excelPreviewFooter">
          <Button type="primary" size="small" @click="excel_update">上传</Button>
        </div>
      </div>
    </Overlay>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, onBeforeMount } from 'vue';
import { Overlay, Form, Field, Button, Pagination, showToast, showLoadingToast, Icon, Popover, closeToast } from 'vant'
import { store } from '@/store/index';
import { useRouter } from 'vue-router';
import 'vant/lib/index.css';
import * as XLSX from 'xlsx';
import { createAdmin, modifySecondAdmin, delAdmin, update_excel } from '@/api/index'

const page = getCurrentInstance()
const add_address_show = ref(false)
const select_address_type = ref(1)
const show_data = ref([])
const showPopover = ref(false)
const actions = ref([
      { text: '去重', type: 1 },
      { text: '范围', type: 2 }
    ])
const query_loading = ref(false)
const one_update_address = ref({
    shopsName: '',
    province: '',
    city: '',
    county: '',
    address: ''
})
const excelData = ref([])
const excel_clock = ref(false)
const excel_update_schedule = ref({ num: 0, total: 0 })
const totalPage = ref(1)
const pageInfo = ref({
  items_per_page: 15,
  total_items: 1,
  show_page_size: 5,
  dataTotal: 1
})

onBeforeMount(() => {})
onMounted(async () => {
    showLoadingToast({
      message: "加载中...",
      duration: 0
    });
    let res = await page.proxy.$apiGet('/getAddress', { pageNum: 1 })
    pageInfo.value.dataTotal = res.data.count
    pageInfo.value.total_items = res.data.count
    show_data.value = res.data.rows
    closeToast();
})

const cahangePage = async () => {
    let res = await page.proxy.$apiGet('/getAddress', { pageNum: totalPage.value })
    show_data.value = res.data.rows
}
const close_address_overlay = () => {
    if (excelData.value.length > 0) return
    add_address_show.value = false
}
const add_address = () => { add_address_show.value = true }
const queryAddress = async () => {
    const textLeg = /[\u4e00-\u9fff]/
    if (!textLeg.test(one_update_address.value.shopsName)) {
        one_update_address.value.shopsName = ''
        showToast('商铺名仅支持中文')
        return
    }
    if (!textLeg.test(one_update_address.value.province)) {
        one_update_address.value.province = ''
        showToast('省份仅支持中文')
        return
    }
    if (!textLeg.test(one_update_address.value.city)) {
        one_update_address.value.city = ''
        showToast('城市仅支持中文')
        return
    }
    if (!textLeg.test(one_update_address.value.county)) {
        one_update_address.value.county = ''
        showToast('区县仅支持中文')
        return
    }
    query_loading.value = true
    const { province, shopsName, address, city, county } = one_update_address.value
    let addressInfo = city + county + address
    let res = await page.proxy.$apiGet('/addressAnalysis', { 'city': province, 'address': addressInfo })
    query_result.value = res.data
    setTimeout(async () => {
        query_loading.value = false
        if (res.data.message != 'Success') {
            showToast('查询失败')
            return
        }
        await page.proxy.$apiGet('/updateAddress', getUpdate_data(shopsName, address))
        showToast('上传成功')
        one_update_address.value = { shopsName: '', province: '', city: '', county: '', address: '' }
        cahangePage()
    }, 300)
}
const upLoad_barChange = (type) => { select_address_type.value = type }
const onSelect = async (e) => {
    let { type } = e
    if (type == 1) {
        const result = confirm("您确定要执行吗？执行后数据将无法恢复!");
        if (result) {
            let showLoading = showLoadingToast({ message: '正在去除重复数据，请勿使用页面！！！', duration: 0 });
            await page.proxy.$apiGet('/del_dz_repeat_data')
            setTimeout(() => { cahangePage(); showLoading.close() }, 3000)
        }
    } else if (type == 2) {
        let rangeRes = await page.proxy.$apiGet('/get_Range')
        let prores = prompt('当前查询范围为:' + rangeRes.data[0].range + '公里')
        if (prores != '') {
            let number = prores.match(/\d+/g)
            let range_updateLoading = showLoadingToast({ message: '更新中...', loadingType: 'spinner', duration: 0 });
            setTimeout(async () => {
                await page.proxy.$apiGet('/modifyQuery_range', { range: number[0] })
                range_updateLoading.close()
                showToast('更新' + res.data)
            }, 500)
        }
    }
}
const handleFileUpload = (event) => {
    let excel_data_loading = showLoadingToast({ message: 'excel解析中...', loadingType: 'spinner', duration: 0 });
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const filteredData = jsonData.filter(row => row.length > 0);
        let trimmedData = filteredData.slice(1);
        trimmedData = trimmedData.map(row => row.slice(0));
        excel_data_loading.close()
        if (trimmedData.length == 0) { showToast('该表格无数据，请重新选择'); return }
        excelData.value = trimmedData
    };
    reader.readAsArrayBuffer(file);
}
const getUpdate_data = (shopsName, address) => {
    let result = query_result.value.result || {}
    let addrComp = result.address_components || {}
    let loc = result.location || {}
    return {
        'province': addrComp.province,
        'city': addrComp.city,
        'county': addrComp.district,
        'address': address,
        'shopsname': shopsName,
        'latitude': loc.lat,
        'longitude': loc.lng
    }
}
let query_result = ref([])
const excel_update = () => {
    if (excel_clock.value) return
    excel_clock.value = true
    let excel_data_inspect = showLoadingToast({ message: '数据校验中...', loadingType: 'spinner', duration: 0 });
    setTimeout(async () => {
        let excel_upData = excelData.value
        for (let i = 0; i < excel_upData.length; i++) {
            for (let a = 0; a < 5; a++) {
                if (excel_upData[i][a] === '' || excel_upData[i][a] === null || excel_upData[i][a] === undefined) {
                    excel_data_inspect.close()
                    alert('第' + (i + 1) + '行数据有问题，请检查')
                    excel_clock.value = false
                    return
                }
            }
        }
        excel_data_inspect.close()
        excel_update_schedule.value = { num: 0, total: excelData.value.length }
        let upload_loading = showLoadingToast({ message: '上传中,请勿刷新页面...', loadingType: 'spinner', duration: 0 });
        let total = excelData.value.length
        for (let i = 0; i < total; i++) {
            let city = excelData.value[i][1]
            let addressInfo = excelData.value[i][1] + excelData.value[i][2] + excelData.value[i][3] + excelData.value[i][4]
            let res = await page.proxy.$apiGet('/addressAnalysis', { 'city': city, 'address': addressInfo })
            query_result.value = res.data
            if (res.data.status != 0) {
                await page.proxy.$apiGet('/updateAddress', getUpdate_data(excelData.value[i][0], excelData.value[i][4]))
                await cahangePage()
            } else {
                upload_loading.close()
                showToast(excelData.value[i][0] + ' 解析失败，已停止')
                excel_clock.value = false
                return
            }
        }
        upload_loading.close()
        showToast('上传完成')
        close_excel_data()
        excel_clock.value = false
    }, 1000);
}
const close_excel_data = () => {
    excelData.value = []
    const fileInput = document.getElementById('fileInput');
    if (fileInput) fileInput.value = ''
}
const delAddress_click = async (item) => {
    let res = confirm('确认删除店铺名为:' + item.shopsname + '的数据吗?删除后将无法恢复')
    if (!res) return
    let del_loading = showLoadingToast({ message: '删除中', loadingType: 'spinner', duration: 0 });
    setTimeout(async () => {
        let isDel = await page.proxy.$apiGet('/delAddress', { id: item.id })
        del_loading.close()
        cahangePage()
        showToast('删除' + isDel.data)
    }, 1000);
}
</script>

<style scoped>
/* ===== 滚动条 ===== */
.addressManage ::-webkit-scrollbar { width: 5px; }
.addressManage ::-webkit-scrollbar-track { background: transparent; }
.addressManage ::-webkit-scrollbar-thumb { background: rgba(99,102,241,0.35); border-radius: 3px; }
.addressManage ::-webkit-scrollbar-thumb:hover { background: rgba(99,102,241,0.6); }

/* ===== 容器：弹性列布局 ===== */
.addressManage {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f0f2f5;
}

/* ===== 右上角设置按钮 ===== */
.topBar_actions {
  position: absolute;
  right: 20px;
  top: 12px;
  z-index: 10;
}
.topBar_actions :deep(.van-icon) {
  font-size: 22px;
  color: #888;
  cursor: pointer;
  transition: color 0.2s;
}
.topBar_actions :deep(.van-icon):hover {
  color: #4f46e5;
}

/* ===== 主卡片 ===== */
.mainCard {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin: 16px 20px 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  overflow: hidden;
}

/* ===== 表格头 ===== */
.cardHeader {
  display: flex;
  background: #f8f9fc;
  padding: 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  position: sticky;
  top: 0;
  border-bottom:1px solid #ebedf0;
}
.cardHeader span {
  flex: 1;
  text-align: center;
  padding: 0 8px;
}
.cardHeader span:last-child {
  flex: 0.8;
}

/* ===== 表格体（可滚动）===== */
.cardBody {
  flex: 1;
  overflow-y: auto;
}
.tableRow {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.15s;
  cursor: pointer;
}
.tableRow:last-child {
  border-bottom: none;
}
.tableRow:hover {
  background: #e8ecff;
}
.tableRow span {
  flex: 1;
  text-align: center;
  font-size: 13px;
  color: #333;
  padding: 10px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}
.tableRow span:last-child {
  flex: 0.8;
}
.addrText {
  text-align: left !important;
  white-space: normal !important;
}

/* ===== 操作按钮 ===== */
.rowActions {
  display: flex;
  gap: 8px;
  justify-content: center;
}
.actionBtn {
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s;
  user-select: none;
}
.actionBtn--del {
  color: #ef4444;
}
.actionBtn--del:hover {
  color: #dc2626;
}

/* ===== 空状态 ===== */
.emptyTip {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 16px;
  color: #bbb;
}

/* ===== 分页吸底 ===== */
.cardFooter {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-top: 1px solid #ebedf0;
  gap: 16px;
  border-radius: 0 0 12px 12px;
  margin: 0 20px 16px;
}
.pageInfo {
  font-size: 13px;
  color: #4f46e5;
  white-space: nowrap;
}

/* ===== 新增按钮（FAB）===== */
.addBtn {
  position: absolute;
  bottom: 28px;
  right: 32px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
  color: #fff;
  font-size: 26px;
  line-height: 52px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(79,70,229,0.4);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  z-index: 20;
  user-select: none;
}
.addBtn:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(79,70,229,0.5);
}
.addBtn:active {
  transform: scale(0.96);
}

/* ===== 弹窗通用 ===== */
.overlayCard {
  width: 340px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.15);
  padding: 24px 20px 20px;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  max-height: 85vh;
  overflow-y: auto;
}
.overlayTitle {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 20px;
}
.overlayClose {
  position: absolute;
  right: 16px;
  top: 14px;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
  z-index: 2;
}
.overlayClose:hover {
  color: #666;
}

/* ===== 切换 Tab ===== */
.typeTabs {
  display: flex;
  border-bottom: 1px solid #e4e8ef;
  margin-bottom: 16px;
}
.typeTab {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #888;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}
.typeTab:first-child {
  border-right: 1px solid #e4e8ef;
}
.typeTab--active {
  color: #4f46e5;
  font-weight: 600;
  border-bottom-color: #4f46e5;
}

/* ===== 提示文字 ===== */
.tips {
  font-size: 12px;
  color: #aaa;
  text-align: left;
  margin-bottom: 8px;
  padding-left: 4px;
}

/* ===== Form 美化 ===== */
.overlayCard :deep(.van-field) {
  margin-bottom: 14px;
  border: 1px solid #e4e8ef;
  border-radius: 10px;
  overflow: hidden;
  font-size: 14px;
}
.submitBtn {
  margin-top: 8px;
}
.overlayCard :deep(.van-button--primary) {
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8) !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(79,70,229,0.3) !important;
}
.fileUploader {
  font-size: 14px;
  margin: 22px 0;
  padding: 12px;
  border: 1px dashed #e4e8ef;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

/* ===== Excel 预览弹窗 ===== */
.excelPreview {
  width: 80%;
  max-width: 680px;
  max-height: 85vh;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.15);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.excelPreviewTitle {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  padding: 16px;
  border-bottom: 1px solid #e4e8ef;
  flex-shrink: 0;
}
.excelPreviewClose {
  position: absolute;
  left: 16px;
  top: 14px;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
  z-index: 2;
}
.excelPreviewClose:hover {
  color: #666;
}
.excelPreviewHeader {
  display: flex;
  background: #f8f9fc;
  padding: 10px 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  flex-shrink: 0;
  border-bottom: 1px solid #ebedf0;
}
.excelPreviewHeader span {
  flex: 1;
  text-align: center;
  padding: 0 8px;
}
.excelPreviewBody {
  flex: 1;
  overflow-y: auto;
}
.excelRow {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
}
.excelRow span {
  flex: 1;
  text-align: center;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 8px;
}
.excelPreviewFooter {
  flex-shrink: 0;
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e4e8ef;
}
</style>
